

export default {
    name: 'server-not-found',
    component: {

    },
    // created(){
    //     this.$router.push("/not-found");
    // }
}
